import React, { useState, useEffect } from 'react'

import { Flex, Card } from 'antd';
import { useNavigate } from "react-router-dom";

import ProfissionalPNG from '../../images/quimico.png'
import EmpresaPNG from '../../images/empresa.png'
import ResponsavelPNG from '../../images/responsavel.png'
import ARTPNG from '../../images/art.png'
import ValidarPNG from '../../images/validar.png'
import DeclaracaoPNG from '../../images/declaracao.png'
import HeaderNoregister from '../../componentes/headerNoRegister';
import { isMobile } from 'react-device-detect';
import APROVADO from '../../images/approved.png'



export const NoRegisterHome = (props) => {

    let navigate = useNavigate()

    useEffect(() => {

    }, [])


    return <Flex vertical>
        <HeaderNoregister />

        <Flex style={{ padding: 25, backgroundColor: '#eef6f3' }} gap={25} justify='center' vertical={isMobile ? true : false}>
            <Card size='small' style={{ minWidth: 160 }}
                title={null} onClick={() => navigate('/consulta/profissional')}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={ProfissionalPNG} />
                    <Flex vertical align='center'>
                        <Flex>Consultar</Flex>
                        <Flex>Profissional</Flex>
                    </Flex>

                </Flex>
            </Card>

            <Card size='small' style={{ minWidth: 150 }}
                title={null} onClick={() => navigate('/consulta/firma')}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={EmpresaPNG} />
                    <Flex vertical align='center'>
                        <Flex>Consultar </Flex>
                        <Flex>Firma</Flex>
                    </Flex>
                </Flex>
            </Card>

            <Card size='small' style={{ minWidth: 150 }}
                title={null} onClick={() => navigate('/consulta/art')}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={ARTPNG} />
                    <Flex vertical align='center'>
                        <Flex>Consultar </Flex>
                        <Flex>ART</Flex>
                    </Flex>

                </Flex>
            </Card>

            <Card size='small' style={{ minWidth: 150 }}
                title={null} onClick={() => navigate('/valida/certidao-crt')}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={ResponsavelPNG} />
                    <Flex vertical align='center'>
                        <Flex>Validar Certidão</Flex>
                        <Flex>Resp. Técnica</Flex>
                    </Flex>

                </Flex>
            </Card>

            <Card size='small' style={{ minWidth: 150 }}
                title={null} onClick={() => navigate('/valida/certificado/pj')}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={APROVADO} />
                    <Flex vertical align='center'>
                        <Flex>Validar</Flex>
                        <Flex> Certificado PJ</Flex>
                    </Flex>
                </Flex>
            </Card>

            {/*
            <Card size='small' style={{ minWidth: 180 }}
                title={null}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={DeclaracaoPNG} />
                    <Flex>Declaração de Quítação</Flex>
                </Flex>
            </Card>
           */}

            <Card size='small' style={{ minWidth: 180 }}
                title={null} onClick={() => {
                    navigate("/valida/declaracao-quitacao")
                }}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={ValidarPNG} />
                    <Flex vertical align='center'>
                        <Flex>Validar Declaração</Flex>
                        <Flex>de Quítação</Flex>
                    </Flex>
                </Flex>
            </Card>

            {/*
            <Card size='small' style={{ minWidth: 180 }}
                title={null} onClick={() => navigate('/validar/crt')}>
                <Flex align='center' gap={5} vertical justify='center' style={{ cursor: 'pointer' }}>
                    <img height={45} src={ResponsavelPNG} />
                    <Flex>Validar CRT</Flex>
                </Flex>
            </Card>

           */}


        </Flex>



        <Flex justify='center' style={{ marginTop: 20 }}>

        </Flex>

        <div style={{ textAlign: 'justify', margin: 50, paddingTop: isMobile ? 5 : 70, paddingLeft: isMobile ? 5 : 130, paddingRight: isMobile ? 5 : 130, paddingBottom: isMobile ? 5 : 70 }}>
            <Flex vertical align='center' gap={15}>
                <span style={{ fontSize: '1.3em' }}><span style={{ color: '#07b15f' }}>MEU</span><strong style={{ color: '#094b80' }}>CRQCE</strong></span>
                <div>
                    A área do registrado no  Conselho Regional de Química da 10ª Região (CRQ10/CE) foi desenvolvida para oferecer praticidade,
                    agilidade e autonomia aos profissionais e empresas devidamente inscritos, reunindo diversos serviços essenciais em um ambiente
                    digital seguro e acessível. Para acesso a todos os serviços disponíveis clique em <a href={'/login'} style={{ color: 'black' }}>Acessar</a>
                </div>
            </Flex>

        </div>

    </Flex>


}


export default NoRegisterHome